<template>
  <v-container style="max-width: 1800px !important">
    <v-alert-dialog ref="alert" />

    <div class="pa-3">
      <v-row>
        <v-col cols="12" class="d-flex">
          <v-card outlined class="pa-4 flex-grow-1 d-flex align-center">
            <v-list-item class="pa-0">
              <v-list-item-avatar size="48" color="orange lighten-5" class="mr-3">
                <v-icon size="28" color="orange darken-2">mdi-file-document-alert-outline</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <div class="text-body-2 grey--text text--darken-2 mb-1">
                  Número de adendas pendientes de carga
                </div>
                <div class="d-flex align-center">
                  <span class="text-h5 font-weight-bold mr-3">{{ nf(stats.adendas_num) }}</span>
                  <v-chip x-small outlined color="orange darken-2">Pendientes</v-chip>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="3">
          <v-text-field v-model.lazy="search.codigoEmpleado" label="Código de empleado" clearable dense hide-details outlined />
        </v-col>
        <v-col cols="3">
          <v-text-field v-model.lazy="search.nombre" label="Nombre" clearable dense hide-details outlined />
        </v-col>
        <v-col cols="3">
          <v-text-field v-model.lazy="search.apellidoPaterno" label="Apellido Paterno" clearable dense hide-details outlined />
        </v-col>
        <v-col cols="3">
          <v-text-field v-model.lazy="search.apellidoMaterno" label="Apellido Materno" clearable dense hide-details outlined />
        </v-col>
        <v-col cols="3">
          <v-text-field v-model.lazy="search.rfc" label="RFC" clearable dense hide-details outlined />
        </v-col>
        <v-col cols="3">
          <v-autocomplete v-model="search.tipoPuestos" :items="areas" item-value="id_rh_area" item-text="nombre" label="Tipos de Puestos" multiple chips deletable-chips clearable dense hide-details outlined @change="search.puestos = []" />
        </v-col>
        <v-col cols="3">
          <v-autocomplete v-model="search.puestos" :items="puestosFiltrados" item-value="id_puesto" item-text="nombre" label="Puestos" multiple chips deletable-chips clearable dense hide-details outlined />
        </v-col>
        <v-col cols="3">
          <v-btn block color="primary" text outlined :loading="loading" :disabled="loading" @click="getItems">
            <v-icon>mdi-magnify</v-icon>Buscar
          </v-btn>
        </v-col>
      </v-row>

      <v-data-table v-model="selected" :headers="headers" :items="items" :loading="loading" item-key="id_empleado_puesto_adenda" show-select checkbox-color="primary" class="mt-4">
        <template v-slot:[`item.nombre_completo`]="{ item }">
          {{ nombreCompleto(item) }}
        </template>
        <template v-slot:[`item.periodo`]="{ item }">
          {{ periodo(item) }}
        </template>
        <template v-slot:[`item.acciones`]="{ item }">
          <v-tooltip bottom color="black">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small v-bind="attrs" v-on="on" @click="abrirCarga(item)">
                <v-icon small>mdi-upload</v-icon>
              </v-btn>
            </template>
            <span>Cargar adenda firmada</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <v-btn class="mt-4" block color="primary" :disabled="selected.length === 0" @click="abrirGeneracion">
        <v-icon left>mdi-download</v-icon>
        Obtener adendas seleccionadas
      </v-btn>
    </div>

    <v-dialog v-model="dialogCarga" max-width="600px" persistent>
      <v-card>
        <v-card-title>Cargar adenda firmada</v-card-title>
        <v-card-text>
          <v-row class="mb-2">
            <v-col cols="12" sm="6">
              <div class="caption grey--text text--darken-1">Empleado</div>
              <div class="font-weight-medium">{{ nombreCompleto(adendaParaCarga) }}</div>
              <div v-if="adendaParaCarga.codigo_empleado" class="caption grey--text text--darken-1">{{ adendaParaCarga.codigo_empleado }}</div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="caption grey--text text--darken-1">Adenda</div>
              <div class="font-weight-medium">{{ adendaParaCarga.nombre_adenda || 'N/D' }}</div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="caption grey--text text--darken-1">Motivo</div>
              <div>{{ adendaParaCarga.nombre_motivo || 'N/D' }}</div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="caption grey--text text--darken-1">Puesto</div>
              <div>{{ adendaParaCarga.nombre_puesto || 'N/D' }}</div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="caption grey--text text--darken-1">Vigencia</div>
              <div>{{ periodo(adendaParaCarga) }}</div>
            </v-col>
          </v-row>
          <v-divider class="mb-4" />
          <v-file-input v-model="archivoAdenda" accept="application/pdf,.pdf" label="Documento PDF" outlined dense show-size />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cerrarCarga">Cancelar</v-btn>
          <v-btn color="primary" :loading="savingCarga" @click="cargarAdenda">Cargar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogGeneracion" persistent max-width="800px">
      <v-card elevation="0">
        <v-card-title class="d-flex justify-space-between align-center">
          <span>Generación masiva de adendas</span>
          <v-btn v-if="pasoGeneracion <= 1" icon @click="cerrarGeneracion"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-stepper v-model="pasoGeneracion">
            <v-stepper-header>
              <v-stepper-step :complete="pasoGeneracion > 1" step="1">Información adicional</v-stepper-step>
              <v-divider />
              <v-stepper-step :complete="pasoGeneracion > 2" step="2">Generando adendas</v-stepper-step>
              <v-divider />
              <v-stepper-step step="3">Descarga</v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-alert type="info" dense outlined>
                  Indica el lugar de firma para generar {{ selected.length }} {{ selected.length === 1 ? 'adenda' : 'adendas' }}.
                </v-alert>
                <v-select v-model="ciudad" :items="lugaresFirma" label="Lugar de firma" outlined dense />
                <v-btn block color="primary" :loading="savingGeneracion" @click="iniciarGeneracion">
                  <v-icon left>mdi-file-cog-outline</v-icon>Iniciar generación
                </v-btn>
              </v-stepper-content>
              <v-stepper-content step="2">
                <div class="text-center py-8">
                  <v-progress-circular indeterminate color="primary" size="64" />
                  <div class="text-h6 mt-4">Generando adendas…</div>
                  <div class="text-body-2 grey--text">Por favor espera mientras se prepara el archivo ZIP.</div>
                </div>
              </v-stepper-content>
              <v-stepper-content step="3">
                <v-alert type="success" text>Las adendas fueron generadas correctamente.</v-alert>
                <v-btn block color="primary" @click="descargarAdendas"><v-icon left>mdi-download</v-icon>Descargar adendas</v-btn>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>
        <v-card-actions><v-spacer /><v-btn text @click="cerrarGeneracion">Cerrar</v-btn></v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import VAlertDialog from '@/components/VAlertDialog.vue'

export default {
  components: { VAlertDialog },
  data: () => ({
    loading: false,
    savingCarga: false,
    savingGeneracion: false,
    items: [],
    selected: [],
    stats: { adendas_num: 0 },
    defaultStats: { adendas_num: 0 },
    areas: [],
    puestos: [],
    dialogCarga: false,
    adendaParaCarga: {},
    archivoAdenda: null,
    dialogGeneracion: false,
    pasoGeneracion: 1,
    ciudad: null,
    idJobGeneracion: null,
    resultadoGeneracion: null,
    intervaloGeneracion: null,
    lugaresFirma: ['Villahermosa, Tab.', 'Puebla, Pue.'],
    search: { codigoEmpleado: '', nombre: '', apellidoPaterno: '', apellidoMaterno: '', rfc: '', tipoPuestos: [], puestos: [] },
    headers: [
      { text: '# Empleado', value: 'codigo_empleado' },
      { text: 'Nombre', value: 'nombre_completo' },
      { text: 'Puesto', value: 'nombre_puesto' },
      { text: 'Periodo', value: 'periodo' },
      { text: 'Adenda', value: 'nombre_adenda' },
      { text: 'Motivo', value: 'nombre_motivo' },
      { text: 'Acciones', value: 'acciones', sortable: false, align: 'center' }
    ]
  }),
  computed: {
    ...mapState(['token']),
    puestosFiltrados () {
      if (!this.search.tipoPuestos.length) return this.puestos
      return this.puestos.filter(puesto => this.search.tipoPuestos.includes(puesto.id_rh_area))
    }
  },
  mounted () {
    this.cargarCatalogos()
    this.getItems()
  },
  beforeDestroy () {
    this.detenerIntervaloGeneracion()
  },
  methods: {
    async cargarCatalogos () {
      try {
        const [areas, puestos] = await Promise.all([
          axios.get('/RHCatalogos/ListarRHAreas'),
          axios.get('/RecursosHumanos/ListarPuestos')
        ])
        this.areas = areas.data || []
        this.puestos = puestos.data || []
      } catch (error) {
        this.mostrarError('No se pudieron cargar los filtros de adendas.')
      }
    },
    getUrl () {
      const url = new URL('http://localhost/RecursosHumanos/ListarEmpleadosAdendas')
      const search = this.search

      if (search.codigoEmpleado) url.searchParams.append('codigo_empleado', search.codigoEmpleado)
      if (search.nombre) url.searchParams.append('nombre', search.nombre)
      if (search.apellidoPaterno) url.searchParams.append('apellido_paterno', search.apellidoPaterno)
      if (search.apellidoMaterno) url.searchParams.append('apellido_materno', search.apellidoMaterno)
      if (search.rfc) url.searchParams.append('rfc', search.rfc)
      search.tipoPuestos.forEach(id => url.searchParams.append('ids_rh_areas', id))
      search.puestos.forEach(id => url.searchParams.append('ids_puestos', id))

      return url.href.replace('http://localhost', '')
    },
    async getItems () {
      this.loading = true
      this.stats = Object.assign({}, this.defaultStats)
      try {
        const response = await axios.get(this.getUrl())
        const puestosConAdendas = response.data || []
        this.items = puestosConAdendas.flatMap(puesto =>
          (puesto.adendas || []).map(adenda => Object.assign({}, puesto, adenda))
        )
        this.stats.adendas_num = this.items.length
        this.selected = []
      } catch (error) {
        this.mostrarError(this.mensajeError(error, 'No se pudieron obtener las adendas pendientes.'))
      } finally {
        this.loading = false
      }
    },
    nombreCompleto (item) {
      return [item.nombre, item.apellido_paterno, item.apellido_materno].filter(Boolean).join(' ')
    },
    periodo (item) {
      return (item.fecha_desde || 'N/D') + ' - ' + (item.fecha_hasta || 'Indefinido')
    },
    pct (value) {
      return (value * 100).toFixed(1) + '%'
    },
    nf (value) {
      return new Intl.NumberFormat('es-MX').format(value || 0)
    },
    abrirCarga (adenda) {
      this.adendaParaCarga = Object.assign({}, adenda)
      this.archivoAdenda = null
      this.dialogCarga = true
    },
    cerrarCarga () {
      this.dialogCarga = false
      this.adendaParaCarga = {}
      this.archivoAdenda = null
    },
    async cargarAdenda () {
      if (!this.archivoAdenda) return this.mostrarError('Debe seleccionar el documento firmado en formato PDF.')
      if (!/\.pdf$/i.test(this.archivoAdenda.name || '')) return this.mostrarError('Solo se aceptan archivos PDF.')
      const formData = new FormData()
      formData.append('id_empleado_puesto_adenda', this.adendaParaCarga.id_empleado_puesto_adenda)
      formData.append('documento', this.archivoAdenda)
      this.savingCarga = true
      try {
        await axios.post('/RecursosHumanos/CargarEmpleadoPuestoAdenda', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        this.cerrarCarga()
        await this.getItems()
      } catch (error) {
        this.mostrarError(this.mensajeError(error, 'No se pudo cargar la adenda.'))
      } finally {
        this.savingCarga = false
      }
    },
    abrirGeneracion () {
      this.pasoGeneracion = 1
      this.ciudad = null
      this.resultadoGeneracion = null
      this.dialogGeneracion = true
    },
    async iniciarGeneracion () {
      if (!this.ciudad) return this.mostrarError('Debe indicar un lugar de firma.')
      this.savingGeneracion = true
      try {
        const response = await axios.post('/RecursosHumanos/GenerarAdendasLanzar', {
          ciudad: this.ciudad,
          adendas: this.selected.map(adenda => ({ id_empleado_puesto_adenda: adenda.id_empleado_puesto_adenda }))
        })
        this.idJobGeneracion = response.data
        this.pasoGeneracion = 2
        this.iniciarIntervaloGeneracion()
      } catch (error) {
        this.mostrarError(this.mensajeError(error, 'No se pudo iniciar la generación de adendas.'))
      } finally {
        this.savingGeneracion = false
      }
    },
    iniciarIntervaloGeneracion () {
      this.detenerIntervaloGeneracion()
      this.intervaloGeneracion = setInterval(this.actualizarEstadoGeneracion, 2000)
    },
    detenerIntervaloGeneracion () {
      if (this.intervaloGeneracion) clearInterval(this.intervaloGeneracion)
      this.intervaloGeneracion = null
    },
    async actualizarEstadoGeneracion () {
      try {
        const response = await axios.get('/RecursosHumanos/AdendaMasivaEstado/' + this.idJobGeneracion)
        if (response.data.completado) {
          this.detenerIntervaloGeneracion()
          this.resultadoGeneracion = response.data.resultado
          this.pasoGeneracion = 3
          this.selected = []
        }
      } catch (error) {
        this.detenerIntervaloGeneracion()
        this.mostrarError('No se pudo consultar el estado de la generación.')
      }
    },
    descargarAdendas () {
      window.open('/api/RecursosHumanos/DescargarAdendas/' + this.resultadoGeneracion + '?jwt=' + this.token, '_blank')
    },
    cerrarGeneracion () {
      this.detenerIntervaloGeneracion()
      this.dialogGeneracion = false
      this.pasoGeneracion = 1
      this.idJobGeneracion = null
      this.resultadoGeneracion = null
      this.ciudad = null
    },
    mensajeError (error, fallback) {
      const data = error && error.response && error.response.data
      return (data && (data.msg || data.message || data.title)) || fallback
    },
    mostrarError (mensaje) {
      this.$refs.alert.setMessage('', mensaje)
      this.$refs.alert.open()
    }
  }
}
</script>

<style scoped>
.kpi-line {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.kpi-figure {
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1;
}

.kpi-pill {
  display: inline-block;
  padding: 2px 8px;
  border: 1px solid #c8e6c9;
  border-radius: 999px;
  background: #e8f5e9;
  color: #2e7d32;
  font-size: 0.85rem;
  font-weight: 600;
}
</style>
